import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';

const navigation = [
  {
    label: 'Коллегам',
    items: [

      { label: 'Возможности для коллег', to: '/resources' },
       { label: 'Вступление в АПП', to: '/join_association' },
      { label: 'Обучение', to: '/benefits/education' },
     
    ],
  },
   {
    label: 'Клиентам',
    items: [
      { label: 'Индивидуальная терапия', to: '/find-psychologist' },
      { label: 'Психотерапевтические группы', to: '/benefits/grupp_psy' },
    ],
  },
];

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const { pathname } = useLocation();

  useEffect(() => {
    setIsMenuOpen(false);
    setOpenDropdown(null);
  }, [pathname]);

  return (
    <header className="site-header">
      <div className="app-container site-header__inner">
        <Link className="site-header__logo" to="/" aria-label="АПП — на главную">
          <img
            src={`${process.env.PUBLIC_URL}/images/logo.png`}
            alt="Ассоциация практикующих психологов"
          />
        </Link>

        <nav className={`site-nav ${isMenuOpen ? 'site-nav--open' : ''}`} aria-label="Основная навигация">
          <div className="site-nav__mobile-heading">Меню</div>

          <NavLink
            className={({ isActive }) => `site-nav__direct${isActive ? ' is-active' : ''}`}
            to="/about"
          >
            Что такое АПП?
          </NavLink>
       

          {navigation.map((group, index) => (
            <div
              className={`site-nav__group ${openDropdown === index ? 'site-nav__group--open' : ''}`}
              key={group.label}
            >
             <button
  className="site-nav__trigger"
  type="button"
  onClick={() => setOpenDropdown(openDropdown === index ? null : index)}
>
  <span>{group.label}</span>
</button>

              <div className="site-nav__dropdown">
                {group.items.map((item) => (
                  <NavLink
                    key={item.to}
                    className={({ isActive }) => `site-nav__dropdown-link${isActive ? ' is-active' : ''}`}
                    to={item.to}
                  >
                    {item.label}
                  </NavLink>
                ))}
              </div>
            </div>
          ))}

          <NavLink
            className={({ isActive }) => `site-nav__direct${isActive ? ' is-active' : ''}`}
            to="/find-psychologist"
          >
            Наши специалисты
          </NavLink>

          

          <div className="site-nav__mobile-social">
            <a href="https://vk.com/spp_psy_tomsk" target="_blank" rel="noopener noreferrer">ВКонтакте</a>
            <a href="https://t.me/spp_psy_tomsk" target="_blank" rel="noopener noreferrer">Telegram</a>
          </div>
        </nav>

        <div className="site-header__actions">
          <div className="site-header__social" aria-label="Социальные сети">
            <a href="https://vk.com/spp_psy_tomsk" target="_blank" rel="noopener noreferrer" aria-label="ВКонтакте">
              <img src={`${process.env.PUBLIC_URL}/images/vk-icon.png`} alt="" />
            </a>
            <a href="https://t.me/spp_psy_tomsk" target="_blank" rel="noopener noreferrer" aria-label="Telegram">
              <img src={`${process.env.PUBLIC_URL}/images/telegram-icon.png`} alt="" />
            </a>
          </div>

          <button
            className={`site-header__burger ${isMenuOpen ? 'site-header__burger--open' : ''}`}
            type="button"
            aria-label={isMenuOpen ? 'Закрыть меню' : 'Открыть меню'}
            aria-expanded={isMenuOpen}
            onClick={() => setIsMenuOpen((value) => !value)}
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </div>
    </header>
  );
}

export default Header;